import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';

export const BorrowingNotes = ({ borrowing }) => {
    const { t } = useLanguage();

    const hasNotes = borrowing.notes || borrowing.reservation_notes || borrowing.return_notes;

    if (!hasNotes) {
        return null;
    }

    return (
        <div className="notes-section">
            <h3>{t('borrowingView.notes')}</h3>
            <div className="notes-grid">
                {borrowing.reservation_notes && (
                    <div className="note-card">
                        <span className="note-icon">📋</span>
                        <div className="note-content">
                            <h4>{t('borrowingView.reservationNotes')}</h4>
                            <p>{borrowing.reservation_notes}</p>
                        </div>
                    </div>
                )}

                {borrowing.notes && (
                    <div className="note-card">
                        <span className="note-icon">📝</span>
                        <div className="note-content">
                            <h4>{t('borrowingView.borrowingNotes')}</h4>
                            <p>{borrowing.notes}</p>
                        </div>
                    </div>
                )}

                {borrowing.return_notes && (
                    <div className="note-card">
                        <span className="note-icon">💬</span>
                        <div className="note-content">
                            <h4>{t('borrowingView.returnNotes')}</h4>
                            <p>{borrowing.return_notes}</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
